module.exports = __webpack_public_path__ + "static/img/quality_page top img_mobile.31aa6615.jpg";